import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

export const PanneVilleFaq = ({ combo }) => {
  const { panne, city } = combo;
  return (
    <section className="section-padding bg-slate-50" data-testid="pv-faq">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-10">
          <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">FAQ</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Questions des habitants de {city.name}
          </h2>
        </div>

        <div className="space-y-4">
          {/* FAQ COMBO unique : panne x ville */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="font-bold text-lg text-slate-900 mb-2">
              Combien de temps pour venir de {city.name} faire {combo.panneShort.toLowerCase()} ?
            </h3>
            <p className="text-slate-700 leading-relaxed">
              {city.name} est à <strong>{city.distanceKm} km</strong> de Mediastore Niort,
              soit <strong>{city.timeMinutes} minutes en voiture</strong> par {city.accessRoad}.
              Pour cette panne, intervention en {panne.durationLabel}. Sur RDV, vous pouvez déposer
              votre appareil le matin et le récupérer l&apos;après-midi (sauf cas spécifiques comme
              désoxydation ou récupération de données).
            </p>
          </div>

          {/* FAQ locale - ville */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="font-bold text-lg text-slate-900 mb-2">{city.localFaqQ}</h3>
            <p className="text-slate-700 leading-relaxed">{city.localFaqA}</p>
          </div>

          {/* 3 premières FAQ de la panne */}
          {panne.faqs.slice(0, 3).map((f) => (
            <div key={f.q} className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="font-bold text-lg text-slate-900 mb-2">{f.q}</h3>
              <p className="text-slate-700 leading-relaxed">{f.a}</p>
            </div>
          ))}

          {/* FAQ click & collect ville */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="font-bold text-lg text-slate-900 mb-2">
              Faites-vous l&apos;expédition Colissimo pour les clients de {city.name} ?
            </h3>
            <p className="text-slate-700 leading-relaxed">
              Oui. Mediastore Niort propose l&apos;<strong>expédition Colissimo gratuite</strong> au-delà
              de 49 € de réparation pour les clients de {city.name} ({city.distanceKm} km). Vous nous
              envoyez votre appareil, nous établissons un diagnostic gratuit sous 24 h, vous validez le
              devis en ligne, et nous renvoyons l&apos;appareil réparé sous 48-72 h. Suivi temps réel
              par code MC-XXXX sur notre{" "}
              <Link to="/click-collect" className="text-red-600 underline">page Click &amp; Collect</Link>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export const PanneVilleInternalLinks = ({ combo, otherCombos }) => {
  const { panne, city } = combo;
  return (
    <section className="section-padding bg-white" data-testid="pv-internal-links">
      <div className="container-custom max-w-5xl">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 text-center">
          Aussi disponible
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-semibold text-slate-700 mb-3 text-sm uppercase tracking-wide">
              {combo.panneShort} dans d&apos;autres villes
            </h3>
            <div className="space-y-2">
              {otherCombos.map((c) => (
                <Link
                  key={c.slug}
                  to={`/${c.slug}`}
                  className="flex items-center justify-between bg-slate-50 hover:bg-red-50 rounded-lg px-4 py-2 text-sm text-slate-700 hover:text-red-700 transition-colors"
                  data-testid={`pv-other-city-${c.city.slug}`}
                >
                  <span>{combo.panneShort} {c.city.name}</span>
                  <span className="text-xs text-slate-400">{c.city.distanceKm} km</span>
                </Link>
              ))}
            </div>
            <Link
              to={`/${panne.slug}`}
              className="text-red-600 text-sm font-medium hover:underline mt-3 inline-block"
            >
              Voir la page principale {combo.panneShort.toLowerCase()} →
            </Link>
          </div>

          <div>
            <h3 className="font-semibold text-slate-700 mb-3 text-sm uppercase tracking-wide">
              Autres réparations à {city.name}
            </h3>
            <div className="space-y-2">
              <Link to={`/reparation-${city.slug}`} className="block bg-slate-50 hover:bg-red-50 rounded-lg px-4 py-2 text-sm text-slate-700 hover:text-red-700 transition-colors">
                📍 Page principale {city.name} (toutes les pannes)
              </Link>
              <Link to="/pannes-reparations" className="block bg-slate-50 hover:bg-red-50 rounded-lg px-4 py-2 text-sm text-slate-700 hover:text-red-700 transition-colors">
                🔧 Voir les 12 pannes traitées
              </Link>
              <Link to="/villes-desservies" className="block bg-slate-50 hover:bg-red-50 rounded-lg px-4 py-2 text-sm text-slate-700 hover:text-red-700 transition-colors">
                🗺️ 18 villes desservies (rayon 80 km)
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
